import { Button, Card, Collapse, Input, Typography } from "antd";
import { useEffect, useMemo, useState } from "react";

const { Text } = Typography;

export default function OutcomePanel({
  open,
  sellerName,
  reasons,
  saving,
  allowSale,
  onSale,
  onConfirm,
  onCancel,
}) {
  const [reasonId, setReasonId] = useState(null);
  const [search, setSearch] = useState("");
  const [product, setProduct] = useState("");
  const [details, setDetails] = useState("");

  useEffect(() => {
    if (!open) {
      setReasonId(null);
      setSearch("");
      setProduct("");
      setDetails("");
    }
  }, [open]);

  const visibleReasons = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return reasons;
    return reasons.filter((reason) =>
      (reason.description || "").toLowerCase().includes(term)
    );
  }, [reasons, search]);

  useEffect(() => {
    if (reasonId && !visibleReasons.some((reason) => reason.id === reasonId)) {
      setReasonId(null);
    }
  }, [visibleReasons, reasonId]);

  if (!open) return null;

  return (
    <Card
      size="small"
      title={
        allowSale
          ? `Como terminou o atendimento de ${sellerName}?`
          : `Por que ${sellerName} não vendeu?`
      }>
      {allowSale && (
        <div style={{ marginBottom: 16 }}>
          <Button
            type="primary"
            size="large"
            loading={saving}
            style={{ height: 48, minWidth: 160 }}
            onClick={onSale}>
            Vendeu
          </Button>
          <Text type="secondary" style={{ marginLeft: 12 }}>
            ou escolha o motivo da não venda
          </Text>
        </div>
      )}

      {reasons.length > 8 && (
        <Input.Search
          allowClear
          placeholder="Buscar motivo"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          style={{ marginBottom: 12 }}
        />
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          gap: 8,
          maxHeight: 260,
          overflowY: "auto",
        }}>
        {visibleReasons.map((reason) => (
          <Button
            key={reason.id}
            size="large"
            type={reasonId === reason.id ? "primary" : "default"}
            style={{
              minHeight: 56,
              height: "auto",
              padding: "8px 12px",
              whiteSpace: "normal",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
            onClick={() => setReasonId(reason.id)}>
            {reason.description}
          </Button>
        ))}
      </div>

      {visibleReasons.length === 0 && (
        <Text type="secondary">
          Nenhum motivo cadastrado para este cliente.
        </Text>
      )}

      <Collapse
        ghost
        style={{ marginTop: 8 }}
        items={[
          {
            key: "extra",
            label: "Produto e observação (opcional)",
            children: (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Input
                  placeholder="Produto"
                  value={product}
                  onChange={(event) => setProduct(event.target.value)}
                />
                <Input.TextArea
                  rows={2}
                  placeholder="Observação"
                  value={details}
                  onChange={(event) => setDetails(event.target.value)}
                />
              </div>
            ),
          },
        ]}
      />

      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <Button
          type="primary"
          size="large"
          loading={saving}
          disabled={!reasonId}
          onClick={() =>
            onConfirm({
              nonsalereason_id: reasonId,
              product: product || null,
              extra_description: details || null,
            })
          }>
          Confirmar
        </Button>
        <Button size="large" onClick={onCancel}>
          Cancelar
        </Button>
      </div>
    </Card>
  );
}
